const REOBSERVE_DELAY = 100

const OBSERVER_CONFIG = [
    { key: 'contentObserver', ref: 'contentEl' },
    { key: 'toolbarObserver', ref: 'appBarEl' },
    { key: 'navObserver', ref: 'bottomEl' },
    { key: 'assessmentImageObserver', ref: 'assessmentImageEl' },
]

export function useSafeLayout(vm) {

    function getAppRoot() {
        if (!vm.$root || !vm.$root.$children) {
            return null
        }

        return vm.$root.$children[0] || null
    }

    function disconnectObservers(app) {
        OBSERVER_CONFIG.forEach(({ key }) => {
            const observer = app[key]

            if (observer && typeof observer.disconnect === 'function') {
                observer.disconnect()
            }
        })
    }

    function reconnectObservers(app) {
        OBSERVER_CONFIG.forEach(({ key, ref }) => {
            const observer = app[key]
            const refEl = app.$refs[ref]

            if (!observer || !refEl) {
                return
            }

            const el = refEl.$el || refEl

            if (typeof observer.observe === 'function') {
                observer.observe(el)
            }

        })
    }

    function performSafeLayoutChange(changeFn) {
        const app = getAppRoot()

        if (app) {
            disconnectObservers(app)
        }

        changeFn()
        setTimeout(() => {
            if (!app || app._isDestroyed) {
                return
            }

            try {
                reconnectObservers(app)
            } catch (error) {
                console.warn('[SafeLayoutBridge] Re-observation failed slightly', error)
            }

        }, REOBSERVE_DELAY)
    }
    return { performSafeLayoutChange }
}
